
import { Component, Vue } from 'vue-property-decorator'
import eventBus from '@/plugins/eventBus'
import { getParameter } from '@/plugins/globals'
import { CategoriesStore } from '@/store/stores/CategoriesStore'
import { envConfiguration } from '@/plugins/globalStaticDatas'
import SubCategoryHeader from '@/modules/headers/SubCategoryHeader.vue'

@Component({
  components: { SubCategoryHeader },
})
export default class CategoryHeader extends Vue {
  selectedCategory = -1
  selectedCategoryPath: any = {}
  hasChildren: boolean = false
  selectedSubcategory: number = 0
  sectorId: any
  showMore: boolean = false
  envConfigurations: any = envConfiguration
  categories: CategoriesStore = CategoriesStore.getInstance()

  selectCategory(category: any, event: any, parentId: any) {
    event.stopPropagation()
    this.selectedCategoryPath = {}
    this.selectedCategory = category.id
    this.selectedCategoryPath[this.selectedCategory] = true
    if (parentId) {
      this.selectedCategoryPath[parentId] = true
    }
    eventBus.$emit('categories:selected', this.selectedCategory)
  }

  showCategory(category: any, index: number) {
    this.selectedSubcategory = category.id
    this.hasChildren = category.children.length !== 0
  }

  hideCategory() {
    this.hasChildren = false
  }

  hideCategories() {
    this.$nextTick(() => {
      let categoriesHeaderWidth = (document.getElementById('categories-header') as HTMLFormElement).offsetWidth - 150
      let categories: any = this.$el.querySelectorAll('li')
      let categoryWidth: Number = 0
      let margin: any = 0

      categories.forEach((category: any) => {
        let style = window.getComputedStyle(category, null)
        let marginLeft = style.marginLeft.replace(/[a-zA-Z]/g, '')
        margin = parseInt(marginLeft) + parseInt(marginLeft)
        categoryWidth += category.offsetWidth + margin
        if (categoryWidth > categoriesHeaderWidth) {
          this.showMore = true
          let el = document.getElementById(category.attributes[0].value) as HTMLFormElement
          el.remove()
        }
      })
    })
  }

  showCategories() {
    eventBus.$emit('categories:showMore')
  }

  beforeMount() {
    this.sectorId = getParameter('sector_id') || this.envConfigurations.sectorID
    this.categories.loadData(this.sectorId, this.hideCategories)
  }
}
